var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 220,
    viewBox: "0 0 225 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1201_26373)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.5,
    cy: 110,
    rx: 112.5,
    ry: 110,
    fill: "#724ACE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 110C224 170.178 174.101 219 112.5 219C50.8989 219 1 170.178 1 110C1 49.822 50.8989 1 112.5 1C174.101 1 224 49.822 224 110Z",
    stroke: "#724ACE",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1201_26373)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M148.99 94.74C146.991 94.74 145.402 96.3287 145.402 98.3275V106.425C145.402 124.567 130.642 139.327 112.5 139.327C94.3574 139.327 79.5974 124.567 79.5974 106.425V98.2762C79.5974 96.2775 78.0086 94.6887 76.0099 94.6887C74.0111 94.6887 72.4224 96.2775 72.4224 98.2762V106.374C72.4224 127.232 88.4636 144.401 108.912 146.246V157.162C108.912 159.161 110.501 160.75 112.5 160.75C114.499 160.75 116.087 159.161 116.087 157.162V146.246C136.485 144.452 152.577 127.232 152.577 106.374V98.2762C152.526 96.3287 150.937 94.74 148.99 94.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 58.25C99.9952 58.25 89.8477 68.3975 89.8477 80.9025V107.142C89.8477 119.647 99.9952 129.795 112.5 129.795C125.005 129.795 135.153 119.647 135.153 107.142V80.9025C135.153 68.3975 125.005 58.25 112.5 58.25ZM119.214 93.8687C118.855 95.2012 117.676 96.0725 116.344 96.0725C116.088 96.0725 115.831 96.0212 115.575 95.97C113.576 95.4062 111.475 95.4062 109.476 95.97C107.836 96.4312 106.248 95.4575 105.838 93.8687C105.376 92.28 106.35 90.64 107.939 90.23C110.963 89.41 114.14 89.41 117.164 90.23C118.701 90.64 119.624 92.28 119.214 93.8687ZM121.93 83.9263C121.469 85.1563 120.341 85.8737 119.111 85.8737C118.753 85.8737 118.445 85.8225 118.086 85.72C114.499 84.3875 110.501 84.3875 106.914 85.72C105.376 86.2838 103.634 85.4638 103.07 83.9263C102.506 82.3888 103.326 80.6462 104.864 80.1337C109.784 78.34 115.216 78.34 120.136 80.1337C121.674 80.6975 122.494 82.3888 121.93 83.9263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1201_26373",
    x: 0,
    y: 0,
    width: 225,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1201_26373"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1201_26373",
    x: 47,
    y: 48,
    width: 131,
    height: 131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1201_26373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1201_26373",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.08e3d391e0582d27da958aaa0ee1a6ab.svg";
export { ForwardRef as ReactComponent };